// extracted by css-extract-rspack-plugin
export default {"cls1":"AboutTheAuthorsSection-cls1_hRN","cls2":"AboutTheAuthorsSection-cls2_A6v AboutTheAuthorsSection-cls1_hRN"};